import axios from "../../config/axiosConfig";

export default {
  post: (data) => axios.post(`/personal/area`, data),
  getBalance: () => axios.get(`/personal/balance`),
  getSupportStatus: () => axios.get(`/personal/tasks_status`),
};
